import React from "react";
import {
  IoMdArrowDropdown,
  IoMdArrowDropup
} from 'react-icons/io';

import "./numberInput.style.css";

const NumberInput = ({
  header,
  count,
  setCount,
  disabled = false
}) => {

  const decrementCount = () => {
    if (count > 0) setCount(count - 1);
  };

  const incrementCount = () => {
    setCount(count + 1);
  };

  const handleChange = (value) => {
    if (typeof value == 'string') {
      if (value.length) value = parseInt(value);
      else {
        value = 0;
      }
    }
    setCount(value);
  };

  return (
    <div className='number-input-container'>
      <label className='number-input-label'>{header}</label>
      <input
        className={`number-input${disabled ? '-disabled' : ''}`}
        type="number"
        name="clicks"
        value={count}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
        disabled={disabled}
      />
      <div className='arrow-icons'>
        <span className='up'>
          <IoMdArrowDropup onClick={disabled ? null : incrementCount} />
        </span>
        <span className='down'>
          <IoMdArrowDropdown onClick={disabled ? null : decrementCount} />
        </span>
      </div>
    </div>
  );
};

export default NumberInput;
